import { render, staticRenderFns } from "./Walletupdate.vue?vue&type=template&id=1db7205c&scoped=true&"
import script from "./Walletupdate.vue?vue&type=script&lang=js&"
export * from "./Walletupdate.vue?vue&type=script&lang=js&"
import style0 from "./Walletupdate.vue?vue&type=style&index=0&id=1db7205c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db7205c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VTextField})
